
define('text!views/template/template.html',[],function () { return '<header id="topHeader"></header>\n<div id="wrapper">\n\t<div id="content"></div>\n</div>';});
